export class FunctionUtil {
  static async esValidoNumero(value) {
    const esNumero = /^-?\d+([.,]?\d+)?$/.test(value);
    return esNumero && parseFloat(value.replace(',', '.'));
  }
  
  static async ejecutarFunction(fn) {
    // eslint-disable-next-line no-new-func
    return new Function('return ' + fn)();
  }
}
